export const AuthCookieName = 'auth';
